import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

export type NationalIdentityType = "ssn" | "sin" | "nino";

export interface NationalIdentitySubmission {
  type: NationalIdentityType;
  number: string;
  consent: boolean;
}

export interface NationalIdentityResult {
  identity: {
    country: string;
    type: NationalIdentityType;
    last_four: string;
    status: "submitted" | "verification_failed" | "verified";
    verified: boolean;
    provider: string;
  };
  verification: {
    status: "submitted" | "verification_failed" | "verified";
    supported: boolean;
    attempted: boolean;
    message?: string | null;
  };
  entity?: Record<string, unknown>;
}

export default function useNationalIdentity(
  options?: MutationOptions<
    APIResponse<NationalIdentityResult>,
    APIError,
    NationalIdentitySubmission
  >,
) {
  const mutation = useMutation<
    APIResponse<NationalIdentityResult>,
    APIError,
    NationalIdentitySubmission
  >(
    (variables) =>
      post(`${API_URL}/account/compliance/national-identity`, variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options,
  );

  return {
    submitNationalIdentity: mutation.mutate,
    submittingNationalIdentity: mutation.isLoading,
    nationalIdentityError: mutation.error,
  };
}
